import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import UploadAsset from "./UploadAsset";
import BasicDetails from "./BasicDetails";


const Details = () => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('details');
  const navigator = useNavigate();
  const params = useParams();
  const uuid = params.id;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);

  const handleChangeTab = (type) =>{
    if(type === "back"){
      navigate("/dashboard/3d");
    }else{
      setActiveKey(type);
    }
  }



  return (
    <>
      <div className='filterhere'>
        <Tabs activeKey={activeKey}  onSelect={(k) => handleChangeTab(k)} >
          <Tab eventKey="back" title={<span> <i className="bi-chevron-left"></i> Back </span>} />
          
          <Tab eventKey="details" title="Details" >
              <BasicDetails />
          </Tab>

          {/* <Tab eventKey="assets" title="Upload Assets" >
              <UploadAsset />
          </Tab> */}
          
        </Tabs>
      </div>
    </>
  );


}

export default Details;